import axios from "../index"

/**
 * 注册
 * userName  手机账号
 * password  密码
 * typeId 所属馆
 * telCode 手机验证码
 * @returns {*}
 */
export function register(params) {
  return axios.post('/portal/reader/register', params)
}

/**
 * 手机验证
 * imageVerification  图形验证码
 * tel    手机号
 * @returns {*}
 */
export function telVerification(params) {
  return axios.post('/portal/reader/telVerification', params)
}

/**
 * 登录
 * userName  手机账号
 * password  密码
 * imageVerification 图形验证码
 * @returns {*}
 */
export function login(params) {
  return axios.post('/portal/reader/login', params)
}

/**
 * 登录
 * imageVerification 拼图验证码
 * @returns {*}
 */
export function loginByImg(params) {
  return axios.post('/portal/reader/loginByImg', params)
}
